<template>
    <div class="newsListPage">
        <div class="main">
            <div class="crumb">
                <router-link to="/pcpage/mainpage/home">
                    <span>{{ $t("message.home") }}</span>
                </router-link>
                <span class="icon">></span>
                <span class="current">{{ $t("message.news") }}</span>
            </div>
            <div class="title">
                {{ $t("message.news") }}
            </div>
            <div class="list">
                <div>
                    <ul >
                        <div v-for="(newsItem, index) in newsList" :key="index" >
                            <li v-if="index<=11">
                                <router-link  :to="{path:'/pcpage/detailpage/newsdetail',query: {id: newsItem.id}}">
                                    <span v-html="newsItem.post_title"></span> 
                                </router-link>
                                <span class="newsTime">{{newsItem.published_time*1000|formatDate}}</span>
                                <div class="line" v-if="isInteger((index+1)/6)"></div>
                            </li>
                            <li v-if="isShow&&index>=12" class="hideNews">
                                <router-link :to="{path:'/pcpage/detailpage/newsdetail',query: {id: newsItem.id}}">
                                    <span v-html="newsItem.post_title"></span> 
                                </router-link>
                                <span class="newsTime">{{newsItem.published_time*1000|formatDate}}</span>
                                <div class="line" v-if="isInteger((index+1)/6)"></div>
                            </li>
                        </div>
                    </ul>
                    <div class="loadMore" @click="showAll" v-if="!isShow">
                        <img src="../img/loadmore.png" alt="">
                        <span>查看更多</span>
                    </div>
                </div>
                
            </div>
        </div>
        <!-- <div class="bottom">
            版权所有 © 2019 孔子学院总部     京ICP 备 08002516号-5
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'newslist',
    data: function() {
        return {
        newsList: [],
        isShow: true
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
    // 判断是否为整数
    isInteger(obj) {
        return obj%1 === 0
    },
    showAll () {
        this.isShow = true
    },
    getNewsList() {
      this.$utils
        .get("portal/api/getNewsList", {
          lang: 'cn',
          start: 0,
          limit: 50
        })
        .then(res => {
          this.newsList = res.data.data.list
          if(this.newsList.length > 12){
              this.isShow = false
          }
        });
    }
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          //this.getNewsList()
      }
    },
  mounted() {
    this.getNewsList()
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsListPage {
    width: 62.5%;
    height: 100%;
    margin: auto;
    background-color: #fff;
    .main {
        padding: 30px 50px 0;
        height: 100%;
        box-sizing: border-box;
        .crumb {
            font-size: 14px;
            a {
                color: #282828;
                text-decoration: none;
            }
            .icon {
                display: inline-block;
                margin: 0 6px;
            }
            .current {
                color: #1c58c1;
            }
        }
        .title {
            margin: 18px 0 18px;
            height: 50px;
            background-color: #e1eef3;
            color: #1c58c1;
            font-size: 28px;
            line-height: 50px;
            font-weight: bold;
            text-indent: 15px;
        }
        .list {
            height: calc(100% - 101px);
            min-height: 560px;
            border: 1px solid #e5e5e5;
            border-bottom: none;
            padding: 30px;
            //overflow-y: auto;
            ul {
                margin: 38px 48px;
                li {
                    list-style-type:disc;
                    cursor: pointer;
                    font-size: 18px;
                    color: #282828;
                    margin-bottom: 15px;
                    line-height: 1.2;
                    .line {
                        margin: 28px 0;
                        height: 1px;
                        background-color: #e5e5e5;
                    }
                    a {
                        color: #282828;
                        text-decoration: none;
                    }
                    a:hover {
                        color: #f3bc65;
                    }
                }
                .newsTime {
                    font-size: 14px;
                    color: #999;
                    margin-left: 15px;
                }
                li:hover {
                    color: #f3bc65;
                }
            }
            .loadMore {
                margin: 20px 48px;
                height: 50px;
                background-color: #e1eef3;
                text-align: center;
                color: #5e696d;
                font-size: 16px;
                line-height: 50px;
                cursor: pointer;
                img {
                    margin-right: 10px;
                }
            }
            .loadMore:hover {
                color: #f3bc65;
            }
        }
    }
}
    .bottom {
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        opacity: 0.5;
    } 
</style>
